// extracted by mini-css-extract-plugin
module.exports = {"settings":"LHC1S","settingsDisabled":"_6tZ+G"};